import ServerRequest from './ServerRequest';

export default class Router {
  constructor() {
    this.paths = [];
  }

  customRequest(url, type, data, dataType = 'json') {
    return (new ServerRequest(url, dataType))[type.toLowerCase()](data);
  }

  addPathString(path) {
    this.paths.push(path);
  }
}
